module.exports = __webpack_public_path__ + "static/media/144-macao.07ffe1db.svg";